import React, { useEffect } from 'react';
import { FC } from 'react';
import { useSequenceStore } from '~/training/sequence/SequenceStore';
import { useGlobalMediaStore } from '~/ui/video-player/GlobalMediaProvider';
import { ItemDefinition, registry, RenderProps } from '../Item';
import { CLOSE_CARD, ItemIds } from '../itemIds';
import { InformationCardButton } from '../doors/components/information/InformationCardButton';
import { Item } from '../Item';
import { EditorMediaFile, useEditorStore } from '~/shell/Store';
import { useDoorsStore } from '../doors/DoorsStore';

export const CloseCard: FC<{
  isSubmit?: boolean;
  text?: string;
  isBlocked?: boolean;
  linkedAudioId?: string;
  cardId?: string;
}> = ({ isSubmit, text, isBlocked, linkedAudioId, cardId }) => {
  const dispatchClose = () => {
    window.dispatchEvent(
      new CustomEvent('close-door-card', { detail: { cardId } })
    );
  };
  const audioItem = undefined as
    { id: string; file: EditorMediaFile; type: string } | undefined;
  const pictureItem = undefined as
    { id: string; file: EditorMediaFile; type: string } | undefined;
  const removedAudio = false;
  const { markDoorCompleted } = useDoorsStore();
  const { audioPlayed } = useSequenceStore();
  const { updateFile, editorMode, updateSequence } = useEditorStore();
  const globalMedia = useGlobalMediaStore();
  const globalPlayer = globalMedia?.player;

  if (globalPlayer && globalPlayer.controlBar) {
    globalPlayer.controls(true);
  }

  const handleClickButton = (isClose: boolean, doorId?: string) => {
    // body editing handled inside dedicated modals now
    if (!isClose && editorMode && removedAudio && cardId !== undefined) {
      updateSequence(cardId, 'audio_ids', []);
    }

    if (!isClose && editorMode && audioItem) {
      updateFile(audioItem.id, audioItem.file, audioItem.type);
    }
    if (!isClose && editorMode && pictureItem) {
      updateFile(pictureItem.id, pictureItem.file, pictureItem.type);
    }
    if (!disabled) {
      if (doorId) {
        markDoorCompleted(doorId);
      }
      if (globalPlayer && editorMode) globalMedia.cleanupPlayer?.();
      dispatchClose();
    }
  };
  const disabledButton = globalPlayer && !editorMode ? true : false;
  const disabled =
    disabledButton ||
    (linkedAudioId && !editorMode ? !audioPlayed[linkedAudioId] : false);
  if (isBlocked || isSubmit) {
    return (
      <div
        className="closeCard"
        // role="button"
        // tabIndex={0}
        style={{
          alignSelf: 'center',
          marginBottom: isBlocked ? '20px' : '0px'
        }}
      >
        <InformationCardButton
          text={isBlocked ? 'Got it!' : text || 'Submit'}
          disabled={disabled}
          handleClickButton={() => handleClickButton(false, cardId)}
        />
      </div>
    );
  }
  return null;
};

class CloseCardItem extends Item<
  typeof CLOSE_CARD,
  { isSubmit?: boolean; text?: string }
> {
  constructor(
    definition: ItemDefinition<
      typeof CLOSE_CARD,
      { isSubmit?: boolean; text?: string }
    >,
    parent: Item<ItemIds, unknown>
  ) {
    super(definition, parent);
  }

  render(props: RenderProps<{ isSubmit?: boolean; text?: string }>) {
    const { isSubmit, text, isBlocked, linkedAudioId, cardId } =
      props as RenderProps<{ isSubmit?: boolean; text?: string }> & {
        isBlocked?: boolean;
        linkedAudioId?: string;
        cardId?: string;
      };
    return (
      <CloseCard
        isSubmit={isSubmit}
        text={text}
        isBlocked={isBlocked}
        linkedAudioId={linkedAudioId}
        cardId={cardId}
      />
    );
  }
}
registry[CLOSE_CARD] = CloseCardItem;
